<template>
  <div class="p404">
    <h1>Sorry this page was not found</h1>
    <p>Go to <router-link :to="{ name: 'home'}">Homepage</router-link></p>
  </div>
</template>
<script>
export default {
  name: 'p404',
  data: () => ({

  })
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/errors/p404.vue